import { Navigate, Outlet, useLocation } from 'react-router-dom';

export function RouteMiddleware() {
  const { pathname } = useLocation<{ pathname: string }>();

  return pathname === '/' ? <Navigate to={{ pathname: '/map' }} /> : <Outlet />;
}
